import { render } from "./popular-four.vue?vue&type=template&id=790b01eb"
import script from "./popular-four.vue?vue&type=script&lang=js"
export * from "./popular-four.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__